/*
 * @Description: 公共接口
 * @Author: sunxiaodong
 * @Date: 2020-07-28 15:54:45
 * @LastEditors: 樊文静
 * @LastEditTime: 2021-08-04 14:04:21
 */

import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host,
  E6_MS_TMS_E6YUN_BASE_WEB,
  // E6_MS_TMS_BUSI_WEB,
  E6_MS_TMS_BASE_WEB
} = e6ModuleOrderWaybillProcessApi;

/************************运单管理公共接口*************************/
// 字典
export function getDicTypeKey(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/findByDicTypeKey`,
    method: "get",
    params
  });
}

/************************运单温度规则相关接口*************************/
//运单温度规则列表
export function getWaybillRulesList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/temperatureRule/page`,
    method: "post",
    data: data
  });
}
// 获取部门列表
export function getDepartmentList() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}
//根据id获取客户信息
export function queryCustomerInfo(id) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/temperatureRule/queryCustomerInfo?id=${id}`,
    method: "get"
  });
}
// 获取报警联系人列表
export function getAllAlarmContact(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/findAllAlarmContact`,
    method: "post",
    data
  });
}
// 获取业务规则条件
export function getRuleConditions(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/configProcessRemindSet/getRuleConditions?firstClassifyId=${data}`,
    method: "get"
  });
}
// 获取业务规则条件
export function modifyRemindSet(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/configProcessRemindSet/modify`,
    method: "post",
    data
  });
}
// 按分类查询业务提醒设置
export function getByClassifyId(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/configProcessRemindSet/getByClassifyId?classifyId=${data}`,
    method: "get"
  });
}
// 删除运单温度规则
export function deleteWaybillRules(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/temperatureRule/deleteBatch`,
    method: "post",
    data
  });
}
// 新增温度规则
export function addWaybillRules(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/temperatureRule/save`,
    method: "post",
    data
  });
}

// 根据id查询规则详细信
export function getWaybillRulesDetails(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/temperatureRule/findRuleById`,
    method: "get",
    params
  });
}
// 修改温度规则
export function updateWaybillRules(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/temperatureRule/update`,
    method: "post",
    data
  });
}
// 查询温度规则历史记录
export function findTemperatureHistoryPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/temperatureRule/findTemperatureHistoryPage`,
    method: "post",
    data
  });
}
